import { render, staticRenderFns } from "./token.vue?vue&type=template&id=71b76778&scoped=true&"
import script from "./token.vue?vue&type=script&lang=js&"
export * from "./token.vue?vue&type=script&lang=js&"
import style0 from "./token.vue?vue&type=style&index=0&id=71b76778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b76778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b76778')) {
      api.createRecord('71b76778', component.options)
    } else {
      api.reload('71b76778', component.options)
    }
    module.hot.accept("./token.vue?vue&type=template&id=71b76778&scoped=true&", function () {
      api.rerender('71b76778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/head/token.vue"
export default component.exports